<template>
  <card-modal :visible="true" :title="title" :showPreview="false" :okText="'Guardar'" :disableOk="true">
    <div id="modal-edit-content" class="content">
      <p class="control">
        <span class="select">
          <select v-model="editLanguage">
            <option v-for="language of languages" 
                    :value="language"
            >{{language.toUpperCase()}}</option>
          </select>
        </span>
        <div class='notification is-warning'>Obrigatório preencher todas as línguas</div>
      </p>
      <div v-for="language of languages"
           v-show="language === editLanguage"
           class="localization columns"
      >
        <div class="column column-quill is-12">
          <p class="control">
            <label class="label">{{'Nome ['+ language.toUpperCase() +']'}}</label>
            <input class="input" type="text" placeholder="Nome do Ponto" v-model="point.name[language]">
          </p>

          <p class="control">
            <label class="label">{{'Descrição ['+ language.toUpperCase() +']'}}</label>
            <quill :ref="'q1' + language" :options="quillOptions"></quill>
          </p>
        </div>
      </div>
    </div>
  </card-modal>
</template>


<script>
import CardModal from '../Util/CardModal'
import Quill from 'vue-bulma-quill'

export default {
  components: {
    Quill,
    CardModal
  },

  props: {
    title: String,
    panoramaId: Number,
    pointId: Number,
    hotspotData: Object
  },
  data () {
    return {
      languages: ['pt', 'en', 'es', 'fr'],
      editLanguage: 'pt',
      point: {
        parentPanoramaId: null,
        pan: null,
        tilt: null,
        fov: null,
        name: {
          pt: null,
          en: null,
          es: null,
          fr: null
        },
        description: {
          pt: null,
          en: null,
          es: null,
          fr: null
        }
      },
      editors: null,
      quillOptions: {
        theme: 'snow',
        formats: ['italic'],
        modules: {
          toolbar: ['italic']
        }
      }
    }
  },
  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    },
    submitIsActive () {
      return this.point.name.pt &&
             this.point.name.en &&
             this.point.name.es &&
             this.point.name.fr
    }
  },
  methods: {
  },
  mounted () {
    this.point.parentPanoramaId = this.panoramaId
    this.editors = {
      pt: {
        q1: this.$refs.q1pt[0].editor
      },
      en: {
        q1: this.$refs.q1en[0].editor
      },
      es: {
        q1: this.$refs.q1es[0].editor
      },
      fr: {
        q1: this.$refs.q1fr[0].editor
      }
    }
    if (this.pointId) {
      for (var l in this.hotspotData.languages) {
        var langData = this.hotspotData.languages[l]
        this.point.name[langData.lang] = langData.name
        this.editors[langData.lang].q1.setContents(langData.description)
      }
    } else {
      this.point.pan = this.hotspotData.pan
      this.point.tilt = this.hotspotData.tilt
      this.point.fov = this.hotspotData.fov
    }
  },
  watch: {
    submitIsActive: function (val) {
      if (val) {
        document.querySelector('.card-modal-ok-btn').classList.remove('is-disabled')
      } else {
        document.querySelector('.card-modal-ok-btn').classList.add('is-disabled')
      }
    },
    currentEvent (val) {
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        this.point.description.pt = this.editors.pt.q1.getContents()
        this.point.description.en = this.editors.en.q1.getContents()
        this.point.description.es = this.editors.es.q1.getContents()
        this.point.description.fr = this.editors.fr.q1.getContents()

        if (!this.pointId) {
          window.store.dispatch('savePanoramaPoint', this.point)
        } else {
          var tmpPoint = this.point
          tmpPoint['pointId'] = this.pointId
          window.store.dispatch('updatePanoramaPoint', tmpPoint)
        }
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    }
  }
}
</script>

<style lang="scss">
  .localization.columns:last-child {
    margin-bottom: 0px;
  }
  .localization.columns:not(:last-child) {
    margin-bottom: 0px;    
  }
</style>


// WEBPACK FOOTER //
// PanoramaHotspotModal.vue?274eba98